import dayjs from 'dayjs'
import moment from 'moment'
import i18n from '@/i18n.js'

export default {
   install(Vue, options) {
      //格式化日期为指定格式的东8区的日期
      Vue.filter(
         'timeFormater',
         function (value, str = 'YYYY/MM/DD日 HH:mm:ss') {
            if (!value) {
               return ''
            }
            return dayjs(new Date(value + '+0800')).format(str)
         }
      )

      //拨打状态
      Vue.filter('convertCallStatus', function (cellValue) {
         let value = i18n.t('other')
         switch (cellValue) {
            case 'ok':
               {
                  value = i18n.t('normalcall')
               }
               break
            case 'error':
               {
                  value = i18n.t('systemerror')
               }
               break
            case 'ivrGiveUp':
               {
                  value = i18n.t('ivrGiveUp')
               }
               break
            case 'waitingGiveUp':
               {
                  value = i18n.t('waitingGiveUp')
               }
               break
            case 'ringingGiveUp':
               {
                  value = i18n.t('ringingGiveUp')
               }
               break
            case 'callerCancelWhileRing':
               {
                  value = i18n.t('ringingGiveUp')
               }
               break
            case 'noSeatOnline':
               {
                  value = i18n.t('noSeatOnline')
               }
               break
            case 'notWorkTime':
               {
                  value = i18n.t('notWorkTime')
               }
               break
            case 'ivrEnd':
               {
                  value = i18n.t('ivrEnd')
               }
               break
            case 'blackList':
               {
                  value = i18n.t('blackList')
               }
               break
            case 'unconnected':
               {
                  value = i18n.t('unconnected')
               }
               break
            case 'unknown':
               {
                  value = i18n.t('unknown')
               }
               break
            case 'notAnswer':
               {
                  value = i18n.t('notAnswer')
               }
               break
            case 'userReject':
               {
                  value = i18n.t('userReject')
               }
               break
            case 'powerOff':
               {
                  value = i18n.t('powerOff')
               }
               break
            case 'numberNotExist':
               {
                  value = i18n.t('numberNotExist')
               }
               break
            case 'busy':
               {
                  value = i18n.t('busy')
               }
               break
            case 'outOfCredit':
               {
                  value = i18n.t('outOfCredit')
               }
               break
            case 'operatorError':
               {
                  value = i18n.t('operatorError')
               }
               break
            case 'callerCancel':
               {
                  value = i18n.t('callerCancel')
               }
               break
            case 'notInService':
               {
                  value = i18n.t('notInService')
               }
               break
            case 'tooManyRequest':
               {
                  value = i18n.t('tooManyRequest')
               }
               break
            case 'clientError':
               {
                  value = i18n.t('clientError')
               }
               break
            case 'seatGiveUp':
               {
                  value = i18n.t('seatGiveUp')
               }
               break
            case 'seatForward':
               {
                  value = i18n.t('seatForward')
               }
               break
            case 'tccc_sdk_user_idCancel':
               {
                  value = i18n.t('cancelled')
               }
               break
            case 'unconnected':
               {
                  value = i18n.t('unconnected')
               }
               break
            default:
               break
         }
         return value
      })

      //转换秒数
      Vue.filter('convertCallTime', function (cellValue) {
         let times = parseInt(cellValue)
         let h = parseInt((times / 60 / 60) % 24)
         let m = parseInt((times / 60) % 60)
         let s = parseInt(times % 60)
         var time = ''
         if (h != 0) {
            time += h + i18n.t('hour')
         }
         if (m != 0) {
            time += m + i18n.t('min')
         }
         time += s + i18n.t('second')
         return time
      })

      Vue.filter('convertCallObj', function (d, info) {
         var call_name = d.um_users__username + '' //um 打电话的人 cm 接电话的人
         var _call_full_phone = d.tccc_call_log_static_rel__caller
         if (d.um_users__user_id == info.userid) {
            //如果是自己打出去的
            call_name = d.cm_contact__contact_name + ''
            _call_full_phone = d.tccc_call_log_static_rel__callee
         }

         if (!call_name) {
            if (_call_full_phone.length > 0) {
               var _prefix = _call_full_phone.substr(0, 4)
               if (['0086', '0085'].indexOf(_prefix) != -1) {
                  _call_full_phone = _call_full_phone.substr(4)
               }
            }
            return _call_full_phone
         } else {
            return call_name
         }
      })

      Vue.filter('convertCallUserObj', function (d, info, type) {
         var call_name = d.um_users__username + '' //um 打电话的人 cm 接电话的人
         var _call_full_phone = d.tccc_call_log_static_rel__caller
         if (d.um_users__user_id == info.userid) {
            //如果是自己打出去的
            call_name = d.cm_contact__contact_name + ''
            _call_full_phone = d.tccc_call_log_static_rel__callee
         }

         if (type == 1) {
            return call_name || i18n.t('unknowncontact')
         } else if (type == 2) {
            if (_call_full_phone.length > 0) {
               var _prefix = _call_full_phone.substr(0, 4)
               if (['0086', '0085'].indexOf(_prefix) != -1) {
                  _call_full_phone = _call_full_phone.substr(4)
               }
            }
            return _call_full_phone
         }
      })

      Vue.filter('convertCallUserObjTwo', function (d, info, type) {
         var call_name = ''
         var _call_full_phone = ''

         if (d.um_users__user_id == info.userid) {
            //如果是自己打出去的
            call_name = d.cm_contact__contact_name + ''
            _call_full_phone =
               d.tccc_seats__callee_ch_soft_tele ||
               d.maybe_callee_extension ||
               d.tccc_call_log_static_rel__callee
         } else {
            //如果是打进来的
            call_name = d.um_users__username + ''
            _call_full_phone =
               d.tccc_seats__caller_ch_soft_tele ||
               d.maybe_caller_extension ||
               d.tccc_call_log_static_rel__caller
         }

         if (type == 1) {
            return call_name || i18n.t('unknowncontact')
         } else if (type == 2) {
            if (_call_full_phone.length > 0) {
               var _prefix = _call_full_phone.substr(0, 4)
               if (['0086', '0085'].indexOf(_prefix) != -1) {
                  _call_full_phone = _call_full_phone.substr(4)
               }
            }
            return _call_full_phone
         }
      })

      Vue.filter('convertCallPhone', function (d, info) {
         var _call_full_phone = d.tccc_call_log_static_rel__caller
         if (d.um_users__user_id == info.userid) {
            //如果是自己打出去的
            _call_full_phone = d.tccc_call_log_static_rel__callee
         }

         if (_call_full_phone.length > 0) {
            var _prefix = _call_full_phone.substr(0, 4)
            if (['0086', '0085'].indexOf(_prefix) != -1) {
               _call_full_phone = _call_full_phone.substr(4)
            }
         }
         return _call_full_phone
      })

      //截取号码长度
      Vue.filter('formatterPhone', function (_call_full_phone, info) {
         if (_call_full_phone.length > 0) {
            var _prefix = _call_full_phone.substr(0, 4)
            if (['0086', '0085'].indexOf(_prefix) != -1) {
               _call_full_phone = _call_full_phone.substr(4)
            }
         }
         return _call_full_phone
      })

      //截取名字长度
      Vue.filter('formatterName', function (d, info) {
         var name = d.um_users__username + '' //um 打电话的人 cm 接电话的人

         if (d.um_users__user_id == info.userid) {
            //如果是自己打出去的
            name = d.cm_contact__contact_name + ''
         }

         var char = ''
         var splitLen = 1
         var sort = 'asc'
         if (name && name.length >= splitLen) {
            if (/.*[\u4e00-\u9fa5]+.*$/.test(name)) {
               if (sort == 'asc') {
                  return name.substring(0, splitLen).toLocaleUpperCase()
               }
               for (var i = name.length - 1; i > 0; i--) {
                  var _tempChat = name[i]
                  char = _tempChat + char
                  splitLen--
                  if (splitLen <= 0) {
                     break
                  }
               }
            } else {
               var arry = name.split(/[-.; '@~'；',]/g)
               for (var j = 0; j < arry.length; j++) {
                  var _char = arry[j]
                  if (!_char) {
                     continue
                  }
                  char += _char.substr(0, 1)
                  splitLen--
                  if (splitLen <= 0) {
                     break
                  }
               }
               char = char.toLocaleUpperCase()
            }
         }
         return /^\d+$/.test(char) || !char ? i18n.t('unkwn') : char
      })

      //截取名字长度
      Vue.filter('convertCallDate', function (cellValue) {
         var currentDate = new Date()
         var _date = new Date(cellValue + '+0800')
         var crdt = moment(_date).format('YYYY/MM/DD HH:mm')
         var _currentStr = moment(currentDate).format('YYYY/MM/DD')
         if (crdt.indexOf(_currentStr) != -1) {
            crdt = crdt.replace(_currentStr, '').replace(' ', '')
         } else {
            //计算天数差（使用moment确保跨天边界计算准确）
            const currentStartOfDay = moment(currentDate).startOf('day')
            const dateStartOfDay = moment(_date).startOf('day')
            const daysDiff = currentStartOfDay.diff(dateStartOfDay, 'days')

            if (daysDiff == 1) {
               //转换为昨天
               crdt = i18n.t('yesterday')
            } else if (daysDiff == 2) {
               //转换为星期
               var weekList = [
                  '星期日',
                  '星期一',
                  '星期二',
                  '星期三',
                  '星期四',
                  '星期五',
                  '星期六',
               ]
               var weelIndex = _date.getDay()
               crdt = i18n.t(weekList[weelIndex])
            } else {
               //判断是今年还是其他年份
               var currentYear = currentDate.getFullYear()
               if (crdt.indexOf(currentYear) != -1) {
                  crdt = _date.getMonth() + 1 + '/' + _date.getDate()
               } else {
                  crdt = moment(_date).format('YYYY/MM/DD')
               }
            }
         }
         return crdt
      })

      //每一项的坐席列表显示
      Vue.filter('getLineItem', function (item, callOutNumber) {
         let displayText =
            (item.alias_name || '') + ' ' + i18n.t('line') + (item.line || '')

         if (item.is_default_mail == 1) {
            displayText += ' ' + i18n.t('default')
         }

         if (callOutNumber) {
            displayText += ' | ' + callOutNumber
         }

         return displayText
      })
   },
}
